import List from '../../../generic/List';
import { classifyRepo } from '../repoState';
import type { Repository } from '../../../../types';

import ConnectableProjectRow from './ConnectableProjectRow';
import DisconnectedProjectRow from './DisconnectedProjectRow';
import ImportedProjectRow from './ImportedProjectRow';
import UnimportedProjectRow from './UnimportedProjectRow';
import type { OnBranchChangeFn, OnImportRepositoryFn, OnSelectRepositoryFn } from './types';

import styles from './index.module.less';

export type HybridProjectsServiceImportRepositoriesTableProps = {
  repositories: Repository[];
  onBranchChange: OnBranchChangeFn;
  selectedRepos: Repository[];
  onSelectRepository: OnSelectRepositoryFn;
  onImportRepository: OnImportRepositoryFn;
};

/**
 * A table component just for hybrid-project imports
 *
 * repositories - Row data for the table
 */
const HybridProjectsTable = ({
  repositories,
  onBranchChange,
  selectedRepos,
  onSelectRepository,
  onImportRepository,
} : HybridProjectsServiceImportRepositoriesTableProps) => {
  return (
    <div className={styles.hybridTable}>
      <List>
        <List.Header>
          <span className={styles.column} />
          <span className={styles.column}>Title</span>
          <span className={styles.column}>Branch</span>
          <span className={styles.column}>Status</span>
          <span className={`${styles.column} ${styles.actionColumn}`}>Action</span>
        </List.Header>
        <List.Body>
          {
            repositories.map((repo: Repository) => {
              switch (classifyRepo(repo)) {
                case 'disconnected':
                  return (
                    <DisconnectedProjectRow
                      repo={repo}
                      selectedRepos={selectedRepos}
                      onBranchChange={onBranchChange}
                      onSelectRepository={onSelectRepository}
                      onImportRepository={onImportRepository}
                    />
                  );
                case 'connected':
                  return (
                    <ImportedProjectRow repo={repo} />
                  );
                case 'connectable':
                  return (
                    <ConnectableProjectRow
                      repo={repo}
                      selectedRepos={selectedRepos}
                      onBranchChange={onBranchChange}
                      onSelectRepository={onSelectRepository}
                      onImportRepository={onImportRepository}
                    />
                  );
                case 'unimported':
                default:
                  return (
                    <UnimportedProjectRow
                      repo={repo}
                      onBranchChange={onBranchChange}
                      onSelectRepository={onSelectRepository}
                      selectedRepos={selectedRepos}
                      onImportRepository={onImportRepository}
                    />
                  );
              }
            })
          }
        </List.Body>
      </List>
    </div>
  );
};

export default HybridProjectsTable;
